export const updateBrowserTabName = (name: string | undefined) => {
  name && (document.title = name);  
}